import type { ReviewQuestion } from '@/types/review/ReviewQuestion';

export const CompetencyStatus = {
    DRAFT: 'Draft',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
} as const;

export type CompetencyStatusType = (typeof CompetencyStatus)[keyof typeof CompetencyStatus];

export interface Competency {
    id: string;
    name: Record<string, string>;
    description: Record<string, string>;
    sortOrder: number;
    status: CompetencyStatusType;
    competencyGroupId?: string;
    copiedFromCompetencyId?: string | null;
    assignedProfilesCount?: number;
    assignedEmployeesCount?: number;
    questions?: ReviewQuestion[];
    isIndividuallyDeactivated?: boolean;
}

export interface CompetencyGroup {
    id: string;
    name: Record<string, string>;
    description: Record<string, string>;
    sortOrder: number;
    status: CompetencyStatusType;
    competencies: Competency[];
}
